/**
 * Componente Toast
 * Wrapper para o message do Ant Design
 */

import { useEffect, useRef } from "react";
import { message } from "antd";

// Função helper para mostrar toasts
export const showToast = (type, content, duration = 3) => {
  const methods = {
    success: message.success,
    error: message.error,
    warning: message.warning,
    info: message.info,
  };

  const method = methods[type] || message.info;
  method(content, duration);
};

// Componente Toast (mantido para compatibilidade, mas usa message do Ant Design)
const Toast = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast) {
      showToast(toast.type, toast.message, toast.duration / 1000);
      // Remove o toast após um delay para evitar acúmulo
      setTimeout(() => {
        onClose?.(toast.id);
      }, toast.duration || 3000);
    }
  }, [toast, onClose]);

  return null;
};

// Container de Toasts (mantido para compatibilidade)
export const ToastContainer = ({ toasts, onClose }) => {
  const processedToasts = useRef(new Set());

  useEffect(() => {
    // Processa apenas toasts novos que ainda não foram exibidos
    toasts.forEach(toast => {
      if (!processedToasts.current.has(toast.id)) {
        showToast(toast.type, toast.message, toast.duration / 1000);
        processedToasts.current.add(toast.id);
        
        // Remove o toast da lista de processados após a duração
        setTimeout(() => {
          processedToasts.current.delete(toast.id);
          onClose?.(toast.id);
        }, toast.duration || 3000);
      }
    });
  }, [toasts, onClose]);

  return null;
};

export default Toast;
